import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "@/pages/HomePage";
import AdminPage from "@/pages/AdminPage";

const TOAST_OPTIONS = {
  style: {
    background: '#0f0f0f',
    border: '1px solid rgba(255,255,255,0.1)',
    color: '#fff',
    fontFamily: 'Manrope, sans-serif',
  },
};

function App() {
  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <div className="noise-overlay" />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={TOAST_OPTIONS}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/remix/:slug" element={<HomePage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
